/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import React, { Component } from "react";

// components - atoms
import Button from "components/atoms/Button/Button.js";
import SVG from "components/atoms/SVG/SVG.js";
import Texture from "components/atoms/Texture/Texture.js";

// components - molecules
import FocusLock from "components/molecules/FocusLock/FocusLock.js";

// images
import PerlinNoise from "images/PerlinNoise.png";

// svgs
import SVG_X from "svgs/SVG_X.js";

// utils
import InteractionUtils from "utils/interaction-utils/InteractionUtils.js";

// constants
const CLOSE_BUTTON_CLASSNAME_DEFAULT = String("btn btn-danger p-1");
const CLOSE_BUTTON_FILL_DEFAULT = String("#FFFFFF");
const CLOSE_BUTTON_ICON_DEFAULT = SVG_X;
const CLOSE_BUTTON_SIZE_DEFAULT = String("2rem");
const ESCAPE_KEY = Number("27");
const TEXTURE_DEFAULT = PerlinNoise;
const ZINDEX_DEFAULT = Number("1");

class Modal extends Component {
  constructor(props) {
    super(props);
    // @props: background - String
    // @props: className - String
    // @props: closeButtonClassName - String
    // @props: closeButtonFill - String
    // @props: closeButtonIcon - Object { SVG }
    // @props: closeButtonSize - String
    // @props: closeButtonStyle - Object
    // @props: disableCloseButton - Boolean
    // @props: disableFocusLock - Boolean
    // @props: disableTexture - Boolean
    // @props: style - Object
    // @props: texture - String
    // @props: wrapperClassName - String
    // @props: wrapperStyle - Object
    // @props: zIndex - Number
    // @props: onClose - Function

    this.state = {
      keyPressSubscriberKey: null,
    };
  }

  render() {
    const { props } = this;
    const {
      background,
      children,
      className,
      closeButtonStyle,
      style,
      wrapperClassName,
      wrapperStyle,
    } = props;

    const closeButtonClassName =
      props.buttonClassName || CLOSE_BUTTON_CLASSNAME_DEFAULT;
    const closeButtonFill = props.closeButtonFill || CLOSE_BUTTON_FILL_DEFAULT;
    const closeButtonIcon = props.closeButtonIcon || CLOSE_BUTTON_ICON_DEFAULT;
    const closeButtonSize = props.closeButtonSize || CLOSE_BUTTON_SIZE_DEFAULT;
    const disableCloseButton = props.disableCloseButton || false;
    const disableFocusLock = props.disableFocusLock || false;
    const disableTexture = props.disableTexture || false;
    const texture = props.texture || TEXTURE_DEFAULT;
    const zIndex = props.zIndex || ZINDEX_DEFAULT;

    return (
      <FocusLock
        isLocked={!disableFocusLock}
        className={wrapperClassName}
        style={{
          height: String("100%"),
          left: Number("0"),
          position: String("fixed"),
          top: Number("0"),
          width: String("100%"),
          zIndex,
          ...wrapperStyle,
        }}
      >

        {/* Background */}
        {background && (
          <div
            className={background}
            style={{
              height: String("100%"),
              left: Number("0"),
              position: String("absolute"),
              top: Number("0"),
              width: String("100%"),
              zIndex: Number(zIndex) - Number("2")
            }}
          />
        )}

        {/* Texture */}
        {!disableTexture && (
          <Texture
            imageUrl={texture}
            style={{
              height: String("100%"),
              left: Number("0"),
              position: String("absolute"),
              top: Number("0"),
              width: String("100%"),
              zIndex: Number(zIndex) - Number("1")
            }}
          />
        )}

        {/* Children */}
        <div
          className={className}
          style={{
            height: String("100%"),
            overflowY: String("auto"),
            position: String("absolute"),
            width: String("100%"),
            zIndex,
            ...style
          }}
          onScroll={(e) => InteractionUtils.publish(e)}
        >
          {children}
        </div>

        {/* Close Button */}
        {!disableCloseButton && (
          <Button
            className={closeButtonClassName}
            style={{
              left: Number("0"),
              position: String("absolute"),
              top: Number("0"),
              zIndex: Number(zIndex) + Number("1"),
              ...closeButtonStyle
            }}
            onClick={() => this.handleClose()}
          >
            <SVG fill={closeButtonFill} size={closeButtonSize}>
              {closeButtonIcon}
            </SVG>
          </Button>
        )}
      </FocusLock>
    );
  }

  componentDidMount() {
    const keyPressSubscriberKey = InteractionUtils.subscribe(
      String("keydown"),
      this.handleKeyPress
    );
    this.setState({ keyPressSubscriberKey });
  }

  componentWillUnmount() {
    const { state } = this;
    const { keyPressSubscriberKey } = state;
    InteractionUtils.unsubscribe(keyPressSubscriberKey);
  }

  handleClose = () => {
    const { props } = this;
    const { onClose } = props;
    if (onClose instanceof Function) {
      onClose();
    }
  };

  handleKeyPress = (event) => {
    const { keyCode } = event;
    if (keyCode === ESCAPE_KEY) {
      this.handleClose();
    }
  };
}
export default Modal;
